module.exports = __webpack_public_path__ + "img/ico-cbr.7d6550c6.svg";